export default __webpack_public_path__ + "static/media/oops.bf3f2f07.svg";